<template>
  <!-- App.vue -->

  <v-app>
    <!-- -->
    <app-topbar></app-topbar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <v-dialog v-model="dialog" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กำลังทำงาน โปรดรอสักครู่
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="errorDialog" hide-overlay persistent width="300">
        <v-card color="error" dark>
          <v-card-text> {{errMsg}} </v-card-text>
        </v-card>
      </v-dialog>

      <v-row v-for="(n, i) in 5" :key="i">
        <v-col cols="11"  offset-md="3" md="6"  offset-sm="1" sm="8">
          <v-text-field
            label="กรอกรหัส"
            v-model="values['value' + i]"
            :error-messages="errors"
            :id="'value' + i"
            :ref="'value' + i"
          ></v-text-field>
        </v-col>

        <v-col cols="1" md="1" sm="2">
          <v-file-input
            v-model="image"
            ref="file"
            prepend-icon="mdi-camera"
            accept="image/*"
            @change="handleImage('value' + i)"
            hide-input
            loading="true"
            id="'_files' + i"
          ></v-file-input>
        </v-col>

      </v-row>

      <v-btn class="mr-4" type="submit" :disabled="invalid"> submit </v-btn>
      <v-btn @click="clear"> clear </v-btn>
    </v-main>
  </v-app>
</template>
<script>
import AppTopBar from "../layout/topBarMenu";
const { createWorker } = require("tesseract.js");

export default {
  components: {
    "app-topbar": AppTopBar,
  },
  data() {
    return {
      values: [],
      code_values: [],
      dialog: false,
      errorDialog: false,
      image: "",
      errors: "",
      errMsg: "",
      invalid: true,
      //file:"",
    };
  },

  computed: {


  },

  created() {
    //this.$vuetify.theme.dark = false;
  },

  methods: {
    submit() {
      this.$refs.observer.validate();
    },
    clear() {
      this.$refs.observer.reset();
    },
    // timeout close overlay

    async handleImage($code) {
      //console.log("handleImage");
      if (this.base64 != "") {
        //this.dialog = !this.dialog;
      }
      try{
      const reader = new FileReader();
      reader.readAsDataURL(this.image);
      reader.onload = async (e) => {
        this.base64 = await e.target.result;
        //console.log(this.base64);
      };

      (async () => {
        this.dialog = !this.dialog;
        const worker = createWorker();
        await worker.load();
        await worker.loadLanguage("eng");
        await worker.initialize("eng");
        const {
          data: { text },
        } = await worker.recognize(this.base64);

        if (!this.code_values.includes(text)) {
          this.code_values.push(text);
          this.values[$code] = text;
          this.base64 = "";
          this.dialog = !this.dialog;
        } else {
          //
          this.base64 = "";
          this.dialog = false;
          this.errMsg = "หมายเลขนี้ถูกใช้งานแล้ว";
          this.errorDialog = !this.errorDialog;
          setTimeout(() => {
            //this.responseStatus.alertStatus = false;
            this.image = "";
            this.errorDialog = !this.errorDialog;
          }, 3000);
        }
      })();
      } catch (e){
        console.log(e);
        this.errorDialog = !this.errorDialog;
          setTimeout(() => {
            //this.responseStatus.alertStatus = false;
            this.errMsg = e;
            this.image = "";
            this.errorDialog = !this.errorDialog;
          }, 3000);
      }

      //console.log(this.values)
    },

    watch: {
      code_values: {
        handler() {
          console.log(this.code_values);
        },
      },
      /*
      values: {
        handler() {
            console.log(this.values);
        }
      },
      image: {
        handler() {
            console.log(this.image);
        }
      },
      */
    },
  },
};
</script>